const formatOptions = options => {
	return JSON.parse(JSON.parse(options));
};

export default {
	getParsedNotificationList: state =>
		state.notifications.map(noti => ({
			...noti,
			options: formatOptions(noti.options || {})
		})),
	getLatestNotificationList: state =>
		state.fiveLatestNotifications.map(noti => ({
			...noti,
			options: formatOptions(noti.options || {})
		}))
};
